import * as React from 'react';

import classNames from 'classnames';

import SettingsConstants from 'bundles/account-settings/constants/SettingsConstants';
import { getStatusMessages } from 'bundles/user-account/utils/errorMessageUtils';

import 'css!./__styles__/StatusMessage';

const { Fields, UpdateStates } = SettingsConstants;

type Props = {
  status: string;
  field?: string;
  customMessage?: string | JSX.Element;
  overrideStyles?: { [key: string]: string | number };
};

export default class StatusMessage extends React.Component<Props> {
  getStateMessage() {
    const { status } = this.props;

    const MESSAGES = getStatusMessages;
    switch (status) {
      case UpdateStates.SUCCEEDED:
        return MESSAGES.UPDATE_SUCCEEDED;
      case UpdateStates.FAILED:
        return MESSAGES.UPDATE_FAILED;
      case UpdateStates.FAILED_EMAIL_ADDRESS:
        return MESSAGES.UPDATE_FAILED_EMAIL_ADDRESS;
      case UpdateStates.FAILED_NAME_MALFORMED:
        return MESSAGES.UPDATE_FAILED_NAME_MALFORMED;
      case UpdateStates.FAILED_NAME_FORBIDDEN:
        return MESSAGES.UPDATE_FAILED_NAME_FORBIDDEN;
      case UpdateStates.FAILED_EMAIL_IN_USE:
        return MESSAGES.UPDATE_FAILED_EMAIL_IN_USE;
      case UpdateStates.FAILED_NEW_PASSWORD_NOT_SUFFICIENTLY_COMPLEX:
        return MESSAGES.FAILED_NEW_PASSWORD_NOT_SUFFICIENTLY_COMPLEX;
      case UpdateStates.FAILED_SAME_PASSWORD:
        return MESSAGES.FAILED_SAME_PASSWORD;
      default:
        return MESSAGES.UPDATE_FAILED;
    }
  }

  getFieldMessage() {
    const { field } = this.props;
    const MESSAGES = getStatusMessages;
    switch (field) {
      case Fields.FULL_NAME:
        return MESSAGES.UPDATE_FAILED_FULL_NAME;
      case Fields.EMAIL_ADDRESS:
        return MESSAGES.UPDATE_FAILED_EMAIL_ADDRESS;
      case Fields.NEW_PASSWORD:
        return MESSAGES.UPDATE_FAILED_NEW_PASSWORD;
      case Fields.PASSWORD:
        return MESSAGES.UPDATE_FAILED_PASSWORD;
      default:
        return MESSAGES.UPDATE_FAILED;
    }
  }

  render() {
    const { status, field, customMessage, overrideStyles = {} } = this.props;
    if (
      status !== UpdateStates.FAILED &&
      status !== UpdateStates.SUCCEEDED &&
      status !== UpdateStates.FAILED_NAME_MALFORMED &&
      status !== UpdateStates.FAILED_NAME_FORBIDDEN &&
      status !== UpdateStates.FAILED_EMAIL_IN_USE &&
      status !== UpdateStates.FAILED_EMAIL_ADDRESS &&
      status !== UpdateStates.FAILED_NEW_PASSWORD_NOT_SUFFICIENTLY_COMPLEX &&
      status !== UpdateStates.FAILED_SAME_PASSWORD
    ) {
      return <span />;
    }

    const stateClassNames = classNames('rc-StatusMessage', {
      success: status === UpdateStates.SUCCEEDED,
      error:
        status === UpdateStates.FAILED ||
        status === UpdateStates.FAILED_EMAIL_IN_USE ||
        status === UpdateStates.FAILED_NAME_MALFORMED ||
        status === UpdateStates.FAILED_NAME_FORBIDDEN ||
        status === UpdateStates.FAILED_EMAIL_ADDRESS ||
        status === UpdateStates.FAILED_NEW_PASSWORD_NOT_SUFFICIENTLY_COMPLEX ||
        status === UpdateStates.FAILED_SAME_PASSWORD,
    });
    const message = field ? this.getFieldMessage() : this.getStateMessage();

    return (
      <span role="alert" style={overrideStyles} className={stateClassNames}>
        {customMessage || message}
      </span>
    );
  }
}
